const state = {
    manualRecordDataFields: [
        {
            key: "work_code",
            label: "工單",
            sortable: false,
            class: "font-family-dfyuanstd-w5 table-col-hight"
        },
        {
            key: "project_name",
            label: "製程",
            sortable: false,
            class: "font-family-dfyuanstd-w5 table-col-hight"
        },
        {
            key: "total_weight",
            label: "生產總重(KG)",
            sortable: false,
            class: "font-family-dfyuanstd-w5 table-col-hight"
        },
        {
            key: "modified_at",
            label: "異動日期",
            sortable: false,
            class: "font-family-dfyuanstd-w5 table-col-hight",
        },
        {
            key: "changeUser",
            label: "異動人員",
            sortable: false,
            class: "font-family-dfyuanstd-w5 table-col-hight",
        },
        {
            key: "reason",
            label: "異動原因",
            sortable: false,
            class: "font-family-dfyuanstd-w5 table-col-hight"
        },
        {
            key: "detail",
            label: "明細",
            sortable: false,
            class: "font-family-dfyuanstd-w5 table-col-hight"
        }
    ],
    manualRecordDataItem: [
        // {
        //     MkOrdNO: "11105E0032",
        //     MkPgmID: "005",
        //     MkPgmName: "銑牙長T",
        //     start_time: "2022-05-25 10:30:40",
        //     end_time: "2022-05-26 08:30:40",
        //     ProduceTime: "22小時",
        //     PersonName: "余建志",
        //     ReceiveQty: "10",
        //     BadQty: "0",
        //     combined: "否",
        //     changeDate: "2022-05-26 13:30",
        //     changeUser: "張縕慈",
        //     changeDetail: "",
        //     changeResult: "時間異動",
        // },
        // {
        //     MkOrdNO: "11105E0402",
        //     MkPgmID: "005",
        //     MkPgmName: "銑牙長T",
        //     start_time: "2022-05-26 10:30:40",
        //     end_time: "2022-05-26 10:50:40",
        //     ProduceTime: "20分",
        //     PersonName: "孫鼎騰",
        //     ReceiveQty: "20",
        //     BadQty: "0",
        //     combined: "否",
        //     changeDate: "2022-05-26 14:00",
        //     changeUser: "張縕慈",
        //     changeDetail: "",
        //     changeResult: "製令新增",
        // }
    ],
};
const getters = {
    get_manualRecordDataFields: state => {
        return state.manualRecordDataFields;
    },
    get_manualRecordDataItem: state => {
        return state.manualRecordDataItem;
    }
};
const actions = {
    set_manualRecordDataFields(context, array) {
        context.commit("SET_MANUALRECORDDATAFIELDS", array);
    },
    set_manualRecordDataItem(context, array) {
        context.commit("SET_MANUALRECORDDATAITEM", array);
    },
    clear_manualRecordDataItem(context) {
        context.commit("CLEAR_MANUALRECORDDATAITEM");
    }
};
const mutations = {
    SET_MANUALRECORDDATAFIELDS(state, array) {
        state.manualRecordDataFields = array;
    },
    SET_MANUALRECORDDATAITEM(state, array) {
        state.manualRecordDataItem = array;
    },
    CLEAR_MANUALRECORDDATAITEM(state) {
        state.manualRecordDataItem = [];
    }
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};



// WEBPACK FOOTER //
// ./src/store/modules/manualRecordData.js